<template>
  <div :class="[from === 'report' ? 'fromReport' : 'notFromReport']">
    <div :class="[from === 'report' ? 'report__resultRow' : 'testResult__resultRow']">
      <span
        :class="[from === 'report' ? 'report__resultRow__text' : 'testResult__resultRow__text']"
      >
        <span
          :class="[convertedTestResult.crankingHealthResult === '00' ? 'green-icon' : (convertedTestResult.crankingHealthResult === '01' || convertedTestResult.crankingHealthResult === '05' ? 'red-icon' : 'blue-icon')]"
        >
          <font-awesome-icon
            :icon="['fas', convertedTestResult.crankingHealthResult === '00' ? 'check-circle' : (convertedTestResult.crankingHealthResult === '01' || convertedTestResult.crankingHealthResult === '05' ? 'times-circle' : 'dot-circle')]"
          />
        </span>
        {{$t('testResult.crankingHealthLabel')}}
      </span>
      <span
        :class="[from === 'report' ? 'report__resultRow__text' : 'testResult__resultRow__text']"
      >{{ from === 'report' ? " - " : "" }} {{ getCrankingHealthValue(convertedTestResult.crankingHealthResult) }}</span>
    </div>
    <!-- END OF FIRST -->
    <!-- SECOND -->
    <div :class="[from === 'report' ? 'report__resultRow' : 'testResult__resultRow']" class="mb-4">
      <span
        :class="[from === 'report' ? 'report__resultRow__text' : 'testResult__resultRow__text']"
      >
        <span
          :class="[convertedTestResult.reserveHealthResult === '0' ? 'green-icon' : (convertedTestResult.reserveHealthResult === '1' ? 'red-icon' : 'blue-icon')]"
        >
          <font-awesome-icon
            :icon="['fas', convertedTestResult.reserveHealthResult === '0' ? 'check-circle' : (convertedTestResult.reserveHealthResult === '1' ? 'times-circle' : 'dot-circle')]"
          />
        </span>
        {{$t('testResult.reserveHealthLabel')}}
      </span>
      <span
        :class="[from === 'report' ? 'report__resultRow__text' : 'testResult__resultRow__text']"
      >{{ from === 'report' ? " - " : "" }} {{ getReserveHealthValue(convertedTestResult.reserveHealthResult) }}</span>
    </div>
  </div>
</template>

<script>
import { mapKeys, camelCase } from 'lodash';
export default {
  props: ['currentTestResult', 'from'],
  computed: {
    convertedTestResult() {
      return _.mapKeys(this.currentTestResult, (value, key) => _.camelCase(key));
    }
  },
  methods: {
    getCrankingHealthValue(crankHealth) {
      return crankHealth === '00'
        ? this.$t('testResult.crankingHealthGood')
        : crankHealth === '01'
        ? this.$t('testResult.crankingHealthGoodNeedsRecharge')
        : crankHealth === '05'
        ? this.$t('testResult.crankingHealthEndOfLife')
        : this.$t('testResult.crankingHealthNotValid');
    },
    getReserveHealthValue(reserveHealth) {
      return reserveHealth === '0'
        ? this.$t('testResult.reserveHealthGood')
        : reserveHealth === '1'
        ? this.$t('testResult.reserveHealthPoor')
        : this.$t('testResult.reserveHealthNotValid');
    }
  }
};
</script>

<style lang="scss" scoped>
@import '~@/styles/variables';

.notFromReport {
  .testResult__resultRow {
    &__text {
      &:last-child {
        padding-left: 10px;
        text-align: right;
      }
      @media screen and (max-width: 400px) {
        &:first-child {
          width: 78%;
        }
      }
    }
  }
}

.fromReport {
  .report__resultRow {
    margin-bottom: 20px;

    &__text {
      line-height: 20px;
    }
    .report__resultRow__text {
      line-height: 20px;
      svg {
        font-size: 16px;
        margin-right: 12px;
      }
    }
  }
}

.red-icon {
  color: $red;
}

.green-icon {
  color: $green;
}

.yellow-icon {
  color: $orange;
}

.blue-icon {
  color: $primary;
}
</style>
